import { useState } from 'react';

import {
    autoUpdate,
    flip,
    offset,
    shift,
    useClick,
    useDismiss,
    useFloating,
    useInteractions,
    useRole,
} from '@floating-ui/react';

import { tokens } from './CurrencySelector.tokens';

export function useCurrencySelectorPopover() {
    const [open, onOpenChange] = useState(false);

    const { refs, floatingStyles, context } = useFloating({
        open,
        onOpenChange,
        placement: 'bottom-start',
        middleware: [
            offset(tokens.popover.offset),
            flip({
                fallbackAxisSideDirection: 'end',
            }),
            shift(),
        ],
        // TODO: Re-positioning on scroll is janky.
        whileElementsMounted: autoUpdate,
    });

    const click = useClick(context);
    const dismiss = useDismiss(context);
    const role = useRole(context);
    const { getReferenceProps, getFloatingProps } = useInteractions([click, dismiss, role]);

    return {
        open,
        onOpenChange,
        context,
        setReference: refs.setReference,
        setFloating: refs.setFloating,
        floatingStyles,
        getReferenceProps,
        getFloatingProps,
    };
}
